
<a [href]="link" target="_blank">
<div class="caixa sombra-legal">
  <img src="assets/link.png" style="margin-left: 3px;margin-top:2px" width="25px">
  <span class="texto">{{texto}} </span>
</div>
</a>
